const STORAGE_PREFIX = 'yh:jobws'

function storageKey(jobId: string): string {
  return `${STORAGE_PREFIX}:${jobId}:collapsedStages`
}

export function readCollapsedPipelineColumns(jobId: string): Set<string> {
  if (typeof window === 'undefined') return new Set()
  try {
    const raw = window.localStorage.getItem(storageKey(jobId))
    if (!raw) return new Set()
    const parsed = JSON.parse(raw) as unknown
    if (!Array.isArray(parsed)) return new Set()
    return new Set(parsed.filter((entry): entry is string => typeof entry === 'string'))
  } catch {
    return new Set()
  }
}

export function writeCollapsedPipelineColumns(jobId: string, collapsed: Iterable<string>): void {
  if (typeof window === 'undefined') return
  try {
    window.localStorage.setItem(storageKey(jobId), JSON.stringify([...collapsed]))
  } catch {
    // ignore quota / private mode
  }
}
